module.exports = __webpack_public_path__ + "img/card-amex.9054612f.svg";